import { get, isEmpty, isNil } from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { RuntimeContext } from '../../../common/RuntimeContext';
import { getCollection, getManyLearningAssets } from '../../shared/actions/index';
import Image from '../../shared/components/Image';
import RichTextDisplay from '../../shared/components/RichTextDisplay';
import VerbButton, { VERB_BUTTON_TYPE } from '../../shared/components/VerbButton';
import { SECTION_ITEM_TYPES } from '../../shared/Constants';
import { getSlideObject } from '../../shared/utils/WorkspaceUtils';

class ReferenceGuidePDF extends PureComponent {
    static propTypes = {
        collectionName: PropTypes.string,
        learnerName: PropTypes.string,
        company: PropTypes.object,
        referenceSectionItems: PropTypes.array,
        profile: PropTypes.object,
        isVerbAdmin: PropTypes.bool,
        match: PropTypes.object,
        getManyLearningAssets: PropTypes.func,
        getCollection: PropTypes.func,
        collectionId: PropTypes.string,
        userLearningAssetsById: PropTypes.object
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
        this.refResources = {};
    }

    componentDidMount() {
        const { match = {}, getManyLearningAssets, getCollection, collectionId = '' } = this.props;
        const referenceGuideCollectionId = match?.params?.id || collectionId;
        if (referenceGuideCollectionId) {
            return getCollection({ collectionId: referenceGuideCollectionId, pathsContext: this.context.pathsWeb })

            .then((collection) => {
                    const learningAssetIds = collection.contentIds.map((content) => content.id);
                    const promises = [
                        getManyLearningAssets({
                            _id: learningAssetIds,
                            getFullProjection: true,
                            pathsContext: this.context.pathsWeb
                        })
                    ];
                    return Promise.all(promises);
                })
                .then(() => {
                    this.setState({
                        loading: false
                    });
                });
        }
        return null;
    }

    downloadPDF = () => {
        window.print();
    };

    _createSlides = () => {
        const { referenceSectionItems, profile, userLearningAssetsById = {} } = this.props;

        if (!referenceSectionItems.length) {
            return [];
        }
        const slides = [];
        referenceSectionItems.forEach((sectionItem) => {
            if (isNil(sectionItem)) {
                return;
            }

            const sectionItemName = sectionItem.name || '';
            const formattedSectionItemType = (sectionItem.type || '').toLocaleUpperCase();
            const workspaceProps = { currentUserTrack: { track: {} }, currentUser: profile };

            const allSectionItemsFromAllActivities = { currentUserTrack: { track: { sectionItemById: {} } } };

            let allCompletedSectionItemsFromAllActivities = {};
            Object.keys(userLearningAssetsById).forEach((itemKey) => {
                const { completedSectionItems = {} } = userLearningAssetsById[itemKey];
                const currentSectionItems =
                    allSectionItemsFromAllActivities?.currentUserTrack?.track?.sectionItemById || {};
                referenceSectionItems.forEach((item) => {
                    if (completedSectionItems[item.id]) {
                        allSectionItemsFromAllActivities.currentUserTrack.track.sectionItemById = {
                            ...currentSectionItems,
                            ...(userLearningAssetsById[itemKey]?.track?.sectionItemById || {})
                        };

                        allCompletedSectionItemsFromAllActivities = {
                            ...allCompletedSectionItemsFromAllActivities,
                            ...userLearningAssetsById[itemKey]?.completedSectionItems
                        };
                        workspaceProps.currentUserTrack = allSectionItemsFromAllActivities.currentUserTrack;
                        workspaceProps.completeSections = allCompletedSectionItemsFromAllActivities;
                    }
                });
            });
            const eventHandlers = {};
            let trackData;
            let newSlideObject;

            if (formattedSectionItemType === SECTION_ITEM_TYPES.THIS_OR_THAT_PERMUTATION_CONTENT) {
                const questions = get(sectionItem, 'content.questions', []);
                questions.forEach((question, i) => {
                    const sectionItemCopy = JSON.parse(JSON.stringify(sectionItem));
                    const questionsCopy = JSON.parse(JSON.stringify(questions));
                    questionsCopy.splice(i, 1);
                    sectionItemCopy.content.questions = [question];
                    trackData = {
                        formattedSectionItemType,
                        sectionItem: sectionItemCopy,
                        referenceSectionItems,
                        sectionItemName
                    };

                    newSlideObject = getSlideObject({
                        trackData,
                        workspaceProps,
                        eventHandlers,
                        isPreview: true,
                        isRefSheet: true,
                        pathsContext : this.context.pathsWeb
                    });
                    slides.push(newSlideObject);
                });
            } else {
                trackData = { formattedSectionItemType, sectionItem, referenceSectionItems, sectionItemName };
                newSlideObject = getSlideObject({
                    trackData,
                    workspaceProps,
                    eventHandlers,
                    isPreview: true,
                    isRefSheet: true,
                    pathsContext : this.context.pathsWeb
                });

                if (formattedSectionItemType === 'SHOW PREVIOUS ANSWERS') {
                    if (workspaceProps.completeSections && !isEmpty(workspaceProps.completeSections)) {
                        slides.push(newSlideObject);
                    }
                } else {
                    slides.push(newSlideObject);
                }
            }
        });
        return slides;
    };

    addToRefResources = (resource, index) => {
        const slideResources = resource.replace('<p>Paths-crafted micro-learning experience.</p>', '');
        this.refResources[index] = slideResources;
    };

    checkDescriptionForResources = (content, index) => {
        let allContent = '';
        const { blocks } = content;

        blocks.forEach((block) => {
            let resourceTag = '';
            if (block.description && block.description.includes('<strong>Resource</strong>')) {
                resourceTag = '<strong>Resource</strong>';
            }

            if (block.description && block.description.includes('<strong>Resources</strong>')) {
                resourceTag = '<strong>Resources</strong>';
            }

            if (resourceTag) {
                if (block.description && block.description.split(resourceTag)[1]) {
                    // remove Paths-crafted micro-learning experience from resources
                    const blockResources = block.description
                        .split(resourceTag)[1]
                        .replace('<p>Paths-crafted micro-learning experience.</p>', '');
                    allContent = `${allContent} ${blockResources}]}`;
                    // eslint-disable-next-line prefer-destructuring
                    block.description = block.description.split(resourceTag)[0];
                }
            }
        });

        if (!this.refResources[index]) {
            this.refResources[index] = allContent;
        }
    };

    getResourcesSection = (resources) => (
        <div className={'no-horizontal-margin resource-block'}>
            <div>
                <p>
                    <strong>Resources</strong>
                </p>
            </div>
            <div>
                <p>Paths-crafted micro-learning experience.</p>
            </div>
            {resources.map((resource) => (
                <div>
                    <RichTextDisplay className={'playerDescription'} htmlToDisplay={resource} />
                </div>
            ))}
        </div>
    );

    render() {
        const { collectionName = '', company: { name = '' } = {}, profile } = this.props;

        const date = new Date();

        const slides = this._createSlides();
        const slideComponents = [];
        slides.forEach((slide, i) => {
            if (slide) {
                const SlideComponent = slide.component;
                const props = slide.componentProps;

                if (props?.content?.resources) {
                    this.addToRefResources(props?.content?.resources, i);
                }
                if (props?.content?.blocks && !props?.content?.resources) {
                    this.checkDescriptionForResources(props?.content, i);
                }

                slideComponents.push(
                    <div key={`${slide.id}${i}`} className={'slide-preview'} style={{ clear: 'both' }}>
                        <SlideComponent {...props} isRefSheet />
                    </div>
                );
            }
        });

        const pathsWebContext = this.context?.pathsWeb ?? {};

        return (
            <div className={'container reference-guide-pdf'}>
                <div className={'row button-row'}>
                    <VerbButton
                        buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT}
                        onClick={() => {
                            this.downloadPDF();
                        }}
                    >
                        PRINT
                    </VerbButton>
                </div>
                <div className={'pdf-content'} id={'capture'}>
                    <div className={'heading'}>
                        <Image
                            src={pathsWebContext.PATHS_LOGO_URL}
                            className={'paths-logo'}
                            alt={'Paths Logo'}
                        />
                        <h2>Summary for {collectionName}</h2>
                        <div className={'subheading'}>{`${profile.firstName} ${profile.lastName}`}</div>
                        <div className={'subheading'}>{name}</div>
                        <div className={'subheading'}>
                            {date.toLocaleString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                        </div>
                    </div>
                    {slideComponents}
                    {!!Object.values(this.refResources).length &&
                        this.getResourcesSection(Object.values(this.refResources))}
                    <div className={'artificialMargin'} style={{ backgroundColor: '#fff', minHeight: 20 }}></div>
                </div>
            </div>
        );
    }
}

export const makeMapStateToProps = () => (state, ownProps) => {
    const {
        collections,
        auth: { loggedInUser, loggedInUserCompanyId },
        learningAssets,
        userLearningAssets,
        companies
    } = state;
    const { match: { params = {} } = {}, collectionId = '' } = ownProps;

    const collection =
        collections.byId[params?.id || collectionId] || collections.byPerma[params?.id || collectionId] || {};

    const loggedInUserCompany = companies && companies.byId && companies.byId[loggedInUserCompanyId];
    const collectionContent = (collection.contentIds || []).map((item) => {
        if (learningAssets.byId[item.id]) {
            return learningAssets.byId[item.id];
        }
        return {};
    });
    let referenceSectionItems = [];
    if (collectionContent.length) {
        referenceSectionItems = collectionContent
            .map((la) => la.sectionItems)
            .flat(1)
            .filter((si) => si && si.isIncludedInDiscussionGuide);
    }

    return {
        collectionName: collection.name,
        company: loggedInUserCompany,
        profile: loggedInUser,
        referenceSectionItems,
        userLearningAssetsById: userLearningAssets.byId
    };
};

export const mapDispatchToProps = (dispatch) => ({
    getCollection: (params) => dispatch(getCollection(params)),
    getManyLearningAssets: (params) => dispatch(getManyLearningAssets(params))
});
export const ReferenceGuidePDFComponent = ReferenceGuidePDF;
export default connect(makeMapStateToProps, mapDispatchToProps)(ReferenceGuidePDF);
